import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    //document.querySelector('.c-modal--pin').classList.remove('c-modal--open');
  }
}